<template lang="pug">
  .faq(v-if="isFaqShowed")
    .section-decor
    .faq__wrap
      FaqDumb(title="FAQ" :questionAnswersList="question_answers_list")
</template>

<script>
import FaqDumb from "@battle_teams_2_components/components/faq/vue/FaqDumb.vue";
import axios from "axios";

export default {
  name: "FAQ",
  components: {
    FaqDumb,
  },
  data() {
    return {
      request_url: "/api/faq/universalpromo",
      question_answers_list: [],
    }
  },
  computed: {
    isFaqShowed() {
      return this.question_answers_list && this.question_answers_list.length;
    },
  },
  mounted() {
    this.getFaq();
  },
  methods: {
    getFaq() {
      axios.get(this.request_url).then(response => {
        if (response.data.data) {
          this.question_answers_list = response.data.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/blocks/faq.scss";
</style>
